import React from 'react'
import { useState } from 'react';
import PortfolioList from '../../components/portfolioList/PortfolioList';
import './portfolio.scss';
import {
    featuredPortfolio,
    mobilePortfolio,
    designPortfolio,
    webPortfolio,
    contentPortfolio,
} from '../../data';
import { useEffect } from 'react';
import { list } from '../../data/portfolioMenu';

export default function Portfolio() {

    const [selected, setSelected] = useState("featured");
    const [data, setData] = useState([]);

    useEffect(() => {
        switch (selected) {
            case "featured":
                setData(featuredPortfolio);
                break;
            case "mobile":
                setData(mobilePortfolio);
            break;
            case "design":
                setData(designPortfolio);
            break;
            case "content":
                setData(contentPortfolio);
            break;
            case "web":
                setData(webPortfolio);
                break;
            default:
                setData(featuredPortfolio);
                break;
        }
    }, [selected]);
    
    return (
        <div className='portfolio' id="portfolio">
            <h1>Portfolio</h1>
            <ul>
                { list.map((item) => {
                    return (
                        <PortfolioList
                            title={ item.title }
                            active={ selected === item.id }
                            setSelected={ setSelected }
                            id={ item.id }
                            key={ item.id}
                        />
                    )
                }) }
            </ul>

            <div className="container">
                { data.map((d) => {
                    return(
                    <div className="item">
                        <img src={ d.img} alt="" />
                        <h3>{ d.title}</h3>
                    </div>
                    )
                })}
            </div>
        </div>
    )
}
